export default defineNuxtPlugin(() => {
  const { public: pub } = useRuntimeConfig()
  const id = pub.gtagId
  if (!id) return

  // --- gtag bootstrap ---
  ;(window as any).dataLayer = (window as any).dataLayer || []
  function gtag(...args: any[]) {
    ;(window as any).dataLayer.push(args)
  }
  ;(window as any).gtag = gtag

  // 1) default denied (Consent Mode v2)
  gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  })

  // 2) load gtag.js
  useHead({
    script: [
      { src: `https://www.googletagmanager.com/gtag/js?id=${id}`, async: true },
      {
        children: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${id}', { send_page_view: true });
        `,
      },
    ],
  })

  // --- CookieYes -> gtag consent bridge ---

  const updateConsentFromCookieYes = (accepted: string[] = []) => {
    const hasAnalytics =
      accepted.includes("analytics") ||
      accepted.includes("statistics") ||
      accepted.includes("performance")

    const hasAds =
      accepted.includes("advertisement") ||
      accepted.includes("marketing")

    gtag("consent", "update", {
      analytics_storage: hasAnalytics ? "granted" : "denied",
      ad_storage: hasAds ? "granted" : "denied",
      ad_user_data: hasAds ? "granted" : "denied",
      ad_personalization: hasAds ? "granted" : "denied",
    })
  }

  document.addEventListener("cookieyes_consent_update", (e: any) => {
    updateConsentFromCookieYes(e?.detail?.accepted ?? [])
  })

  const tryInit = () => {
    const w = window as any

    if (typeof w.getCkyConsent === "function") {
      try {
        const c = w.getCkyConsent()

        const accepted =
          c?.accepted ??
          c?.consent?.accepted ??
          c?.categories ??
          c?.consent?.categories ??
          []

        if (Array.isArray(accepted)) {
          updateConsentFromCookieYes(accepted)
        }
      } catch {
        // ignore
      }
    }
  }

  setTimeout(tryInit, 0)
  setTimeout(tryInit, 300)
  setTimeout(tryInit, 1200)
})
